import { isEqual } from 'lodash-es'

/** @abstract */
export default class Model {

	/** @type number */ id

	//FIXME: it seems that default values for child classes later override what's set in the constructor...???
	// This was first saw in the Restaurant model... not even tracking changes with logging at `set active()` explains how this happens
	constructor(attrs) {
		//any changes here must sadly be replicated at TimezonedModel
		Object.assign(this, attrs)
	}

	/**
	 * An easy way to map a bunch of entries into new instances.
	 * @param entries {object[]} One of the Model subclasses
	 * @return {Model[]} All entries, mapped to {model}
	 */
	static map(entries) { //TODO: why isn't this a normal map, like list.map(Model.new)??
		return entries? entries.map(attrs => new this(attrs)) : []
	}

	/**
	 * Override freely if a model needs a specific procedure to compare two instances of it.
	 * Then, use it at calls to {@link useSelector()}
	 * @param a {this}
	 * @param b {this}
	 * @returns {boolean}
	 */
	static isEqual(a, b) { return isEqual(a, b) }
}
